export const Types = {
  SET_PDF_WINDOW_OPEN_STATUS: "SET_PDF_WINDOW_OPEN_STATUS"
};

export const setPdfWindowOpenStatus = isOpen => ({
  type: Types.SET_PDF_WINDOW_OPEN_STATUS,
  payload: isOpen
});
